import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CardTitle = ({
  children,
  type,
}) => (
  <div className="CardTitle">
    <span
      className={classnames('CardTitle_label', type)}
    >
      {children}
    </span>
  </div>
);

CardTitle.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any.isRequired,
};

CardTitle.defaultProps = {
  type: null,
};

export default CardTitle;
